import React, { useEffect, useState } from 'react';
import { Routes, Route, useNavigate, Navigate } from 'react-router-dom';
import Frame from './components/Frame';
import DashboardPage from './pages/dashboard';
import Error404Page from './pages/authentication/404';
import Error500Page from './pages/authentication/500';
import Error503Page from './pages/authentication/503';
import SignInPage from './pages/authentication/sign-in';
import SignUpPage from './pages/authentication/sign-up';
import MembersPage from './pages/tables/members';
import VirtualizedTablePage from './pages/tables/virtualized';
import FormBasicPage from './pages/forms/basic';
import FormWizardPage from './pages/forms/wizard';
import CalendarPage from './pages/calendar';
import BuyerC from './components/BuyerC';
import Addprduct from './pages/tables/members/Addproduct';
import BulkProduct from './pages/tables/members/BulkProduct';
import Catalogue from './pages/catalogue/Catalogue';
import Selection from './pages/catalogue/Selection';
import EditDetails from './pages/catalogue/EditDetails';
import AddUser from './pages/addpage/AddUser';
import CompanyMaster from './pages/addpage/CompanyMaster';
import AddBuyer from './pages/buyer/AddBuyer';
import ManageCollection from './pages/manageCatalogue/ManageCollection';
import EditCollection from './pages/manageCatalogue/EditCollection';
import ViewCollection from './pages/manageCatalogue/ViewCollection';
import ManageCatalogue from './pages/manageCatalogue/ManageCatalogue';
import Generate from './pages/catalogue/GenerateCata';
import Generate1 from './pages/catalogue/GenerateCata1';
import GenerateColl from './pages/catalogue/GenerateColl';
import Master from './pages/masters/Master';
import Setting from './pages/settings/Setting';
import Mail from './pages/mail/MailConfig';
import Marketing from './pages/marketing/Marketing';
import MngMarketing from './pages/marketing/MngMarketing';
import BuyerRecom from './pages/manage/BuyerRecom';
import ManageCosting from './pages/manage/ManageCosting';
import ManageFair from './pages/manage/ManageFair';
import ManageOrdQ from './pages/manage/ManageOrdQ';
import CatalogueTemp from './pages/templates lib/CatalogueTemp';
import Controls from './pages/manage/Controrls';
import ClientWeb from './pages/manage/Clientweb';
import ProductViewDetails from './pages/tables/members/ProductView';
import AllTem from './pages/catalogue/PPT/AllTem';
import SelectionQ from './pages/quotation/SelectionQ';
import EditDetailsQ from './pages/quotation/EditDetailsQ';
import GenerateMarketing from './pages/marketing/GenerateMarketing';
import AppTwo from './AppTwo';
import Product from './clientWeb/Products';
import BuyerWeb from './clientWeb/BuyerWeb';
import EditDetailsC from './pages/manageCatalogue/EditDetailsC';
import TradeFair from './pages/tradefair/TradeFairMaster';
import TradeFairCreate from './pages/tradefair/TradeFairCreate';
import TradeFairRemove from './pages/tradefair/TradeFairRemove';
import FinalFair from './pages/tradefair/FinalFair';
import QRPrint from './pages/tradefair/QRprint';
import FairHome from './pages/tradefair/FairHome';
import Settings from './pages/tradefair/Setting';
import EnquiryTracker from './pages/tradefair/EnquiryTracker';
import PriceManage from './pages/tradefair/PriceManage';
import PublicRoute from './helpers/PublicRoute';
import ClientPublicRoute from './helpers/ClientPublickRoute';
import ProtectedRoutes from './helpers/ProtectedRoute';
import MasterAttri from './pages/attriMaster/MasterAttri';
import ManageProduct from './pages/manage/ManageProduct';
import ModifyonTable from './pages/manage/ModifyonTable';
import ClientsProtectedRoutes from './helpers/ClientsProtectedRoutes';
import globalIP from './GlobelIP';
import ugr from './UGRoute';
import axios from 'axios';
import ViewActivitiesPage from './pages/ViewActivities/view-activities-page';
import HeaderWeb from './clientWeb/Header';
import CostingPage from './pages/Costing/costing-page';
import CostingPage1 from './pages/Costing/costing-page1';
import ProductSelectionPage from './pages/Costing/product-selection-page';
import TimeUpPage from './clientWeb/TimeUpPage';
import CostingViewPage from './pages/Costing/costingView/costingView-page';
import SpaceVisualizationPage from './pages/spaceVisualization/spaceVisualization-page';
import SpaceVisualization from './clientWeb/spaceVisualization/spaceVisualization-page';
import HomePage from './clientWeb/HomePages/Home-page';
import SlideShowPage from './clientWeb/SlideShowPage';
import ActivityPage from './clientWeb/MyActivity/Activity-page';
import EnqiryTracker from './pages/enquiryTracker/EnquiryTracker';
import CollectinPage from './clientWeb/collection/collectin-page';
import BulkCosting from './pages/Costing/BulkCosting';
import EditCosting from './pages/Costing/EditCosting';
import AttributeSetup from './pages/attributeSetup/AttributeSetup';
import AdminPanel from './pages/adminPanel/AdminPanel';
import ChangePassword from './pages/authentication/changePassword/ChangePassword';
import GreetingBuyer from './pages/greetings/GreetingBuyer';
import ProtectedAdmin from './ProtectedAdmin';
import PriceList from './pages/tables/pricelist/PriceList';
import CustomerLoginPage from './pages/authentication/sign-in/NewSign';
const App = () => {
  const navigate = useNavigate();

  const userid = localStorage.getItem('id');
  const handleResetLoginCount = async () => {
    await fetch(`${globalIP}/api/user-details/${userid}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        data: {
          LogT: '0',
          LogoutT: new Date().toISOString()
        }
      })
    });
  };
  const session = localStorage.getItem('session_time');
  if (!(new Date(JSON.parse(session)) > new Date())) {
    handleResetLoginCount();
    localStorage.clear();
  }
  const isActive = sessionStorage.getItem('isActive');
  useEffect(() => {
    const isActive = sessionStorage.getItem('isActive');
    if (isActive) {
      const interval = setInterval(async () => {
        const loginTime = sessionStorage.getItem('loginTime');
        const user_id = sessionStorage.getItem('user_id');
        if (loginTime) {
          const main_id = sessionStorage.getItem('main_id');
          const startTime = new Date(loginTime);
          const currentTime = new Date();
          const elapsedTimeInSeconds = Math.floor((currentTime - startTime) / 1000);
          const clinteLogin = await axios.put(`${globalIP}/api/clientactivities/${main_id}`, {
            data: {
              timespent: elapsedTimeInSeconds.toString()
            }
          });
          const { data } = await axios.put(`${globalIP}/api/client-logins/${user_id}?populate=*`, {
            data: {
              recenttimespent: clinteLogin.data.data.attributes.timespent
            }
          });
          if (new Date(data.data.attributes.Timeto) <= currentTime) {
            sessionStorage.clear();
            navigate('/time-up', { state: { isActive: false, timeOver: true } });
          }
          const response = await axios.get(
            `${globalIP}/api/catalogues?populate=*&filters[CatalogueCode][$eq]=${data.data.attributes.typecode}`
          );

          if (response.data.data[0].attributes.Status == 'inActive') {
            sessionStorage.clear();
            navigate('/time-up', { state: { isActive: true, timeOver: false } });
          }
        }
      }, 30000);

      return () => clearInterval(interval);
    }
  }, [isActive]);

  useEffect(() => {
    if (isActive) {
    }
  }, [isActive]);

  const searchParams = new URLSearchParams(location.search);
  const con = searchParams.get('conid');
  const ff = Number(con);
  // const costingpage = 1;
  const [costingpage, setCostingpage] = useState(0);


  useEffect(() => {
    const fetchCostingPage = async () => {
      const response = await fetch(`${globalIP}/api/company-details?populate=*`)
      const json = await response.json()
      setCostingpage(json.data[0].attributes.CostingNo || 1)
    }
    fetchCostingPage()
  }, [])
  return (
    <Routes>
      <Route path="/" element={<Navigate to={`/${ugr}/login`} />} />
      <Route path="*" element={<Error404Page />} />
      <Route path="/" element={<ClientPublicRoute />}>
        <Route path="*" element={<Error404Page />} />
        <Route path={`/${ugr}/`} element={<></>} />
        <Route path={`/${ugr}/client`} element={<></>} />
        <Route path={`/${ugr}/client/apptwo`} element={<AppTwo />} />
        {ff == 1 ? <Route path={`/${ugr}/client/product`} element={<Product />} /> : null}
      </Route>
      <Route path="/" element={<ClientsProtectedRoutes />}>
        <Route path="/" element={<HeaderWeb />}>
          <Route path={`/${ugr}/client/home-page`} element={<HomePage />} />
          <Route path={`/${ugr}/client/product`} element={<Product />} />
          <Route path={`/${ugr}/client/buyers`} element={<BuyerWeb />} />
          <Route path={`/${ugr}/client/slide-show`} element={<SlideShowPage />} />
          <Route path={`/${ugr}/client/space-visualization`} element={<SpaceVisualization />} />
          <Route path={`/${ugr}/client/my-activity`} element={<ActivityPage />} />
          <Route path={`/${ugr}/client/collection`} element={<CollectinPage />} />
          <Route path="*" element={<Error404Page />} />
        </Route>
      </Route>

      <Route path="/" element={<PublicRoute />}>
        {/* <Route path={`/${ugr}/login`} element={<SignInPage />} /> */}
        <Route path={`/${ugr}/login`} element={<CustomerLoginPage />} />
      </Route>
      <Route path="/" element={<ProtectedRoutes />}>
        <Route path="/" element={<Frame navs={[]} />}>
          <Route path={`/${ugr}/dashboard`} element={<DashboardPage />} />
          <Route path={`/${ugr}/products`} element={<MembersPage />} />
          <Route path={`/${ugr}/table-virtualized`} element={<VirtualizedTablePage />} />
          <Route path={`/${ugr}/error-404`} element={<Error404Page />} />
          <Route path={`/${ugr}/error-500`} element={<Error500Page />} />
          <Route path={`/${ugr}/error-503`} element={<Error503Page />} />
          <Route path={`/${ugr}/sign-up`} element={<SignUpPage />} />
          <Route path={`/${ugr}/changePassword`} element={<ChangePassword />} />
          <Route path={`/${ugr}/form-basic`} element={<FormBasicPage />} />
          <Route path={`/${ugr}/form-wizard`} element={<FormWizardPage />} />
          <Route path={`/${ugr}/calendar`} element={<CalendarPage />} />
          <Route path={`/${ugr}/products-create`} element={<Addprduct />} />
          <Route path={`/${ugr}/bulkproduct`} element={<BulkProduct />} />
          <Route path={`/${ugr}/buyer`} element={<BuyerC />} />
          <Route path={`/${ugr}/catalogue`} element={<Catalogue />} />
          <Route path={`/${ugr}/selection`} element={<Selection />} />
          <Route path={`/${ugr}/editDetails`} element={<EditDetails />} />
          <Route path={`/${ugr}/adduser`} element={<AddUser />} />
          <Route path={`/${ugr}/companyMaster`} element={<CompanyMaster />} />
          <Route path={`/${ugr}/manageCollection`} element={<ManageCollection />} />
          <Route path={`/${ugr}/editCollection`} element={<EditCollection />} />
          <Route path={`/${ugr}/viewCollection`} element={<ViewCollection />} />
          <Route path={`/${ugr}/manageCatalogue`} element={<ManageCatalogue />} />
          <Route path={`/${ugr}/generate-catalogue`} element={<Generate />} />
          <Route path={`/${ugr}/generate-catalogue1`} element={<Generate1 />} />
          <Route path={`/${ugr}/generate-collection`} element={<GenerateColl />} />
          <Route path={`/${ugr}/manage-marketing`} element={<MngMarketing />} />
          <Route path={`/${ugr}/buyerRecommendtions`} element={<BuyerRecom />} />
          <Route path={`/${ugr}/manage-Costing`} element={<ManageCosting />} />
          <Route path={`/${ugr}/manageFair`} element={<ManageFair />} />
          <Route path={`/${ugr}/manageOrdQ`} element={<ManageOrdQ />} />
          <Route path={`/${ugr}/marketing`} element={<Marketing />} />
          <Route path={`/${ugr}/templates`} element={<CatalogueTemp />} />
          <Route path={`/${ugr}/setting`} element={<Setting />} />
          <Route path={`/${ugr}/configuration`} element={<Mail />} />
          <Route path={`/${ugr}/addbuyer`} element={<AddBuyer />} />
          <Route path={`/${ugr}/master`} element={<Master />} />
          <Route path={`/${ugr}/controls`} element={<Controls />} />
          <Route path={`/${ugr}/clientweb`} element={<ClientWeb />} />
          <Route path={`/${ugr}/productView`} element={<ProductViewDetails />} />
          <Route path={`/${ugr}/selectionQ`} element={<SelectionQ />} />
          <Route path={`/${ugr}/editDetailsQ`} element={<EditDetailsQ />} />
          <Route path={`/${ugr}/generateMark`} element={<GenerateMarketing />} />
          <Route path={`/${ugr}/editDetailsC`} element={<EditDetailsC />} />
          <Route path={`/${ugr}/alltem`} element={<AllTem />} />
          <Route path={`/${ugr}/masterF`} element={<TradeFair />} />
          <Route path={`/${ugr}/fairCreate`} element={<TradeFairCreate />} />
          <Route path={`/${ugr}/fairRemove`} element={<TradeFairRemove />} />
          <Route path={`/${ugr}/finalEdit`} element={<FinalFair />} />
          <Route path={`/${ugr}/qrPrint`} element={<QRPrint />} />
          <Route path={`/${ugr}/fairHome`} element={<FairHome />} />
          <Route path={`/${ugr}/settings`} element={<Settings />} />
          <Route path={`/${ugr}/enquiry`} element={<EnquiryTracker />} />
          <Route path={`/${ugr}/priceManage`} element={<PriceManage />} />
          <Route path={`/${ugr}/masterAtrributes`} element={<MasterAttri />} />
          <Route path={`/${ugr}/manageProduct`} element={<ManageProduct />} />
          <Route path={`/${ugr}/modify`} element={<ModifyonTable />} />
          <Route path={`/${ugr}/view-activity`} element={<ViewActivitiesPage />} />
          <Route
            path={`/${ugr}/costing`}
            element={costingpage == 1 ? <CostingPage1 /> : <CostingPage />}
          />
          <Route path={`/${ugr}/product-Selection-Page`} element={<ProductSelectionPage />} />
          <Route path={`/${ugr}/costing-view`} element={<CostingViewPage />} />
          <Route path={`/${ugr}/space-visualization`} element={<SpaceVisualizationPage />} />
          <Route path={`/${ugr}/enqury-tracker`} element={<EnqiryTracker />} />
          <Route path={`/${ugr}/bulk-costing`} element={<BulkCosting />} />
          <Route path={`/${ugr}/edit-costing`} element={<EditCosting />} />
          <Route path={`/${ugr}/greetings`} element={<GreetingBuyer />} />
          <Route path={`/${ugr}/attributeSetup`} element={<AttributeSetup />} />
          <Route path={`/${ugr}/pricelist`} element={<PriceList />} />
        </Route>
      </Route>
      <Route
        path={`/${ugr}/admin-panel`}
        // element={
        //   <ProtectedAdmin>
        //     <AdminPanel />
        //   </ProtectedAdmin>
        // }
        element={<AdminPanel />}
      />
      <Route path="*" element={<Error404Page />} />
      <Route path="/time-up" element={<TimeUpPage />} />
    </Routes>
  );
};

export default App;
